import React, { Component, Suspense } from 'react';
import { Panel } from 'react-bootstrap';
import { connect } from 'react-redux';

import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';
import { announcementList, announcementSelect, announcementDelete } from '../../store/actions/announcement';
import { alertAdd } from '../../store/actions/alert';

import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';

import Spinner from '../../components/Spinner/Spinner';

import * as constants from '../../constants';
import { columns, sorting } from './AnnouncementsSchema';
 
const SideMenu = React.lazy(() => import('../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../components/PageHeader/PageHeader'));
const BaseList = React.lazy(() => import('../../components/Lists/BaseList/BaseList'));
const AnnouncementModal = React.lazy(() => import('../../components/Modals/AnnouncementModal/AnnouncementModal'));

class Announcements extends Component {
    state = {
        showEditModal: false,
        canEdit: false,
        hasPermission: false,
        pagePermission: constants.PERMISSION_CONTENT_POPUPNOTICES,
        isMounted: false
    };

    componentDidMount() {
        this.props.onBreadcrumbAddRoute({ key: 'popupNotices', parent: 'Content', text: 'Popup Notices', path: window.location.pathname });
        this.setState({ isMounted: true });
        this.refreshedHandler();
    };

    componentWillMount() {
        this.props.permissions.filter((perm) => {
            if(perm.name === this.state.pagePermission){
                this.setState({ hasPermission: true });
                if(perm.edit === true || perm.edit === 'true'){
                    this.setState({ canEdit: true });
                }
            } 
        });   
    };

    componentWillUnmount() {
        this.props.onBreadcrumbRemoveRoute();
    };

    selectedHandler = (category) => {
        this.props.onAnnouncementSelect({ announcementId: category.id });

        this.setState({ showEditModal: true });
    };

    addedHandler = () => {
        this.props.onAnnouncementSelect();

        this.setState({ showEditModal: true });
    };

    deletedHandler = (category) => {
        this.props.onAnnouncementDelete({ announcementId: category.id });

        this.refreshedHandler();
    };

    cancelledHandler = () => {
        this.setState({ showEditModal: false });
    };

    submittedHandler = () => {
        this.setState({ showEditModal: false });

        this.refreshedHandler();
    };

    refreshedHandler = () => {
        this.props.onAnnouncementList();
    };

    render() {
        let editModal = null;

        if (this.state.showEditModal) {
            editModal = (
                <AnnouncementModal
                    canEdit={this.state.canEdit}
                    show={this.state.showEditModal}
                    cancelled={this.cancelledHandler}
                    submitted={this.submittedHandler} />
            );
        }

        const styles = {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '3em',
            marginTop: '3em',
            border: 0,
        };

        return (
            <>
                { this.state.hasPermission && this.state.isMounted &&
                    <Suspense fallback={<Spinner text="Loading..." />}>
                        {editModal}
                        <SideMenu activeKey="content" />
                        <div className="content-body">
                            <div style={{ paddingRight: '15px' }}>
                                <PageHeader title="Popup Notices" />
                                <Panel>
                                    <Panel.Body>
                                        <div className="row" style={{ paddingTop: '20px' }}>
                                            <div className="col-md-12">
                                                <BaseList
                                                    compType="Popup Notice"
                                                    listData={this.props.announcements}
                                                    sorting={sorting}
                                                    columns={columns}
                                                    isBusy={this.props.lastState === constants.STATE_PROCESSING}
                                                    hideCopy={true}
                                                    hidePrint={true}
                                                    permissionEdit={this.state.canEdit}
                                                    activeValue="Active"
                                                    activeField="statusName"
                                                    added={() => this.addedHandler()}
                                                    selected={(category) => this.selectedHandler(category)}
                                                    deleted={(category) => this.deletedHandler(category)}
                                                    refreshed={() => this.refreshedHandler()} />
                                            </div>
                                        </div>
                                    </Panel.Body>
                                </Panel>
                            </div>
                        </div>
                    </Suspense>
                }
                { !this.state.hasPermission && this.state.isMounted &&
                    <React.Fragment>
                        <div style={{ ...styles }}>
                            <div>
                                <h3>Access Denied</h3>
                            </div>
                        </div>
                    </React.Fragment>
                }
            </>

            
        );
    }
};

const mapStateToProps = (state) => ({
    announcements: state.announcement.announcements,
    lastState: state.announcement.lastState,
    lastScope: state.announcement.lastScope,
    permissions: state.authentication.permissions
});

const mapDispatchToProps = (dispatch) => ({
    onAnnouncementSelect: (options) => dispatch(announcementSelect(options)),
    onAnnouncementList: () => dispatch(announcementList()),
    onAnnouncementDelete: (options) => dispatch(announcementDelete(options)),
    onAlertAdd: (alert) => dispatch(alertAdd(alert)),
    onBreadcrumbAddRoute: (crumb) => dispatch(breadcrumbAddRoute(crumb)),
    onBreadcrumbRemoveRoute: (crumb) => dispatch(breadcrumbRemoveRoute(crumb))
});

export default withLayout(withAuthentication(connect(mapStateToProps, mapDispatchToProps)(Announcements)));
